<template lang="html">
  <div>
    <div class="login__atmosphere">
      <img :src="require('img/login/loginUser.png')" />
    </div>
    <h2 class="login-form__title">{{ $t('login.doubleLogin') }}</h2>
    <p class="login-form__text">
      {{ $t('login.doubleLoginFirstText') }}
    </p>
    <p class="login-form__text">
      {{ $t('login.doubleLoginSecondText') }}
    </p>
    <div class="login-form__link">
      <router-link to="/login" class="login-form__link--section">{{ $t('login.back') }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoubleLogins',
  data () {
    return {
      input: {
        username: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/inputs/doubleLogin.vue